<template>
	<div
		v-if="blok"
		v-editable="blok"
		:class="footerBlocksStyle[`item-${isChildComponentIndex}`]?.wrap || ''"
	>
		<p v-if="blok.title" class="text-sm uppercase">
			{{ blok.title }}
		</p>
		<div
			:class="
				footerBlocksStyle[`item-${isChildComponentIndex}`]?.content ||
				'flex-col leading-[22px] flex'
			"
		>
			<StoryblokComponent
				v-for="(item, index) in blok.items"
				:key="item._uid"
				:blok="item"
				:is-child-component-index="
					item.component === 'footer-column' ? `${index}` : null
				"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { FooterColumn } from "~/types/storyblok/storyblok";

interface Props {
	blok: FooterColumn;
	isChildComponentIndex?: string;
}

const { blok } = defineProps<Props>();

const footerBlocksStyle = {
	"item-0": {
		content: "flex gap-6"
	},
	"item-1": {
		content: "mt-6 flex gap-4"
	}
};
</script>
